import { render, staticRenderFns } from "./45fenghuang.vue?vue&type=template&id=5c059081&"
import script from "./45fenghuang.vue?vue&type=script&lang=js&"
export * from "./45fenghuang.vue?vue&type=script&lang=js&"
import style0 from "./45fenghuang.vue?vue&type=style&index=0&id=5c059081&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports